import React from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { fetchUserJobActivity } from "../../../services/api/user";
import CountUp from "react-countup";

const JobActivity = () => {
  const { id: userId } = useParams();

  const {
    isPending: isJobActivityApiLoading,
    error: isJobActivityApiError,
    data: jobActivityData,
  } = useQuery({
    queryKey: ["jobActivity", userId],
    queryFn: () => fetchUserJobActivity(userId),
    enabled: !!userId,
  });

  return (
    <BaseCard className="py-2 px-8 sm:px-10 rounded-lg" elevation={1}>
      <div className="bg-light -mx-4 px-4 py-2 mt-2 mb-4 rounded-md flex justify-between items-center">
        <h6 className="text-dark font-normal">Job Activity</h6>
      </div>

      <div className="grid grid-cols-5 lg:gap-x-32">
        {/* <div className="xl:col-span-1 col-span-5">
          <p className="text-base font-medium"> Marketplace:</p>
          <div className="bg-light flex items-center justify-between rounded-md py-1.5 px-3 lg:w-[220px] my-3">
            <p>Completed</p>
            <p>
              <CountUp
                start={0}
                end={jobActivityData?.data?.marketplaceCompleted || 0}
                duration={2} // Duration in seconds
                separator=","
              />
            </p>
          </div>
        </div> */}
        <div className="xl:col-span-4 col-span-5">
          <p className="text-base font-medium"> My Company:</p>
          <div className="grid grid-cols-4 gap-4 my-3">
            <div className="lg:col-span-1 col-span-4 bg-light flex items-center justify-between rounded-md py-1.5 px-3 xl:w-[220px]">
              <p>Requested</p>
              <p>
                <CountUp
                  start={0}
                  end={jobActivityData?.data?.requested || 0}
                  duration={2}
                  separator=","
                />
              </p>
            </div>
            <div className="lg:col-span-1 col-span-4 bg-light flex items-center justify-between rounded-md py-1.5 px-3 xl:w-[220px]">
              <p>Routed</p>
              <p>
                <CountUp
                  start={0}
                  end={jobActivityData?.data?.routed || 0}
                  duration={2}
                  separator=","
                />
              </p>
            </div>
            <div className="lg:col-span-1 col-span-4  bg-light flex items-center justify-between rounded-md py-1.5 px-3 xl:w-[220px]">
              <p>Assigned</p>
              <p>
                <CountUp
                  start={0}
                  end={jobActivityData?.data?.assigned || 0}
                  duration={2}
                  separator=","
                />
              </p>
            </div>
            <div className="lg:col-span-1 col-span-4 bg-light flex items-center justify-between rounded-md py-1.5 px-3 xl:w-[220px]">
              <p>Completed</p>
              <p>
                <CountUp
                  start={0}
                  end={jobActivityData?.data?.completed || 0}
                  duration={2}
                  separator=","
                />
              </p>
            </div>
          </div>
        </div>
      </div>
    </BaseCard>
  );
};

export default JobActivity;
